import { render, staticRenderFns } from "./MetadataOriginLabel.vue?vue&type=template&id=26215441&scoped=true&"
import script from "./MetadataOriginLabel.vue?vue&type=script&lang=js&"
export * from "./MetadataOriginLabel.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./MetadataOriginLabel.vue?vue&type=style&index=0&id=26215441&lang=scss&scoped=true&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "26215441",
  "758671fc"
  
)

export default component.exports